import videojs from 'video.js';

const HIGHLIGHT_CLASS = 'vjs-highlighted';

class SubtitlesMenu extends videojs.getComponent('Menu') {
  hideSubtitleOffItem() {
    const item = this.getChildById('subtitles-off');
    if (item) {
      item.removeClass(HIGHLIGHT_CLASS);
      item.hide();
    }
  }

  showSubtitleOffItem() {
    const item = this.getChildById('subtitles-off');
    if (item) {
      item.show();
    }
  }
}
videojs.registerComponent('SubtitlesMenu', SubtitlesMenu);
